"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoint = exports.default = exports.createBreakpointHooks = void 0;
var _reactResponsive = require("react-responsive");
const useBreakpoint = function (_ref) {
  let {
    up = false,
    down = false,
    minWidth,
    maxWidth
  } = _ref;
  return (0, _reactResponsive.useMediaQuery)({
    minWidth: down ? undefined : minWidth,
    maxWidth: up ? undefined : maxWidth
  });
};
exports.useBreakpoint = useBreakpoint;
const createBreakpointHooks = function (breakpoints) {
  return {
    useMobileBreakpoint: function (props) {
      return useBreakpoint({
        maxWidth: breakpoints.mobile,
        ...props
      });
    },
    useTabletBreakpoint: function (props) {
      return useBreakpoint({
        minWidth: breakpoints.mobile + 1,
        maxWidth: breakpoints.tablet,
        ...props
      });
    },
    useDesktopBreakpoint: function (props) {
      return useBreakpoint({
        minWidth: breakpoints.tablet + 1,
        maxWidth: breakpoints.desktop,
        ...props
      });
    },
    useXLDesktopBreakpoint: function (props) {
      return useBreakpoint({
        minWidth: breakpoints.desktop + 1,
        ...props
      });
    },
    useBreakpointName: function (props) {
      const mobile = (0, _reactResponsive.useMediaQuery)({
        maxWidth: breakpoints.mobile,
        ...props
      });
      const tablet = (0, _reactResponsive.useMediaQuery)({
        minWidth: breakpoints.mobile + 1,
        maxWidth: breakpoints.tablet,
        ...props
      });
      if (mobile) return "mobile";
      if (tablet) return "tablet";
      return "desktop";
    }
  };
};
exports.createBreakpointHooks = createBreakpointHooks;
var _default = exports.default = useBreakpoint;